import store from './../store'

import { Emit, Watch, Prop } from 'vue-property-decorator'

class Noti {
  notis: any = []
  menuOpen = store.state.menu.open

  constructor() { }
  
  activateSideMenu(activate) {
    console.log("activateSideMenu in notif", activate)
    if (!activate) {
      activate = !this.menuOpen
    }
    this.menuOpen = activate
    store.commit('setMenu', this.menuOpen)
    
  }
    
  sayNoti(msg, timeout = 3000) {
    let id = String(Math.random())
    this.notis.unshift({ id:id, msg: msg, timeout: timeout })
    setTimeout((_id)=>{
      this.destroy(_id)
    }, timeout, id)
    return id
  }

  destroy(notiId) {
    console.log("destroying noti", notiId)
    let ind = this.notis.find((itm) => {
      return itm.id = notiId
    })
    if (ind) {
      this.notis.splice(ind,1)  
    }
  }
  
}

export const notiSrv = new Noti()
